<template>
  <div id="teaStorageMaintain">
    <div class="container">
      <div class="scene-container">
        <div ref="sceneRef" class="scene"></div>

        <div class="info-panel">
          <div class="storage-item" v-for="(item, index) in storageData" :key="index">
            <div class="storage-header">
              <span class="storage-name">{{ item.name }}</span>
              <span class="storage-status" :class="getStatusClass(getFillPercent(item))">
                {{ getStatusText(getFillPercent(item)) }}
              </span>
            </div>

            <div class="form-row">
              <div class="form-group-half">
                <label>物料名称</label>
                <input v-model="item.name" type="text" class="form-input" placeholder="请输入物料名称" />
              </div>
              <div class="form-group-half">
                <label>掉粉值</label>
                <input v-model.number="item.powderValue" type="number" class="form-input" placeholder="请输入掉粉值" step="0.1" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group-half">
                <label>满量值 (kg)</label>
                <input v-model.number="item.fullValue" type="number" class="form-input" placeholder="满量值" step="0.1" @change="updateWarningLine(index)" />
              </div>
              <div class="form-group-half">
                <label>预警值 (kg)</label>
                <input v-model.number="item.warningValue" type="number" class="form-input" placeholder="预警值" step="0.1" @change="updateWarningLine(index)" />
              </div>
            </div>

            <div class="storage-info">
              <span>容量: {{ formatPercent(getFillPercent(item)) }}%</span>
              <span>剩余: {{ getRemainingValue(item) }} kg</span>
            </div>

            <button class="save-btn" @click="saveStorageInfo(index)">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import {TeaMaintainService} from '@/service/TeaMaintainService'

export default {
  name: 'teaStorageMaintain',
  data() {
    return {
      sceneRef: null,
      storageData: [],
      scene: null,
      camera: null,
      renderer: null,
      containers: [],
      teaLevels: [],
      animationId: null,
        // ts
        teaMaintainService: null,
        equipmentId:0
    }
  },
  methods: {
      // ts code
      async loadData(){
        const response = await this.teaMaintainService.getMaintain({equipmentId:this.equipmentId})
        if (response.success) {
            this.storageData = this.normalizeStorageData(response.data)
            this.rebuildSceneByData()
        } else {
            this.$message.error(response.message)
        }
      },

    toNumber(value, defaultValue = 0) {
      const n = Number(value)
      return Number.isFinite(n) ? n : defaultValue
    },
    normalizeStorageData(data) {
      const list = Array.isArray(data) ? data : []
      return list.filter(item => item).map((item) => {
        const d = Object.assign({}, item)
        if (d.name == null && d.materialName != null) d.name = d.materialName
        if (d.powderValue == null && d.powderLoss != null) d.powderValue = d.powderLoss
        if (d.fullValue == null && d.fullCapacity != null) d.fullValue = d.fullCapacity
        if (d.fullValue == null && d.capacity != null) d.fullValue = d.capacity
        return d
      })
    },
    getFullValue(data) {
      const d = data || {}
      const v = d.fullValue != null ? d.fullValue : (d.fullCapacity != null ? d.fullCapacity : (d.capacity != null ? d.capacity : d.maxCapacity))
      return this.toNumber(v, 0)
    },
    getWarningValue(data) {
      const d = data || {}
      const v = d.warningValue != null ? d.warningValue : (d.warnValue != null ? d.warnValue : d.warning)
      return this.toNumber(v, 0)
    },
    getRemainingValue(data) {
      const d = data || {}
      const v = d.remaining != null ? d.remaining : (d.remainingValue != null ? d.remainingValue : (d.remainValue != null ? d.remainValue : (d.currentValue != null ? d.currentValue : (d.current != null ? d.current : d.amount))))
      return this.toNumber(v, 0)
    },
    getFillPercent(data) {
      const d = data || {}
      const ratioRaw = d.percent != null ? d.percent : d.ratio
      if (ratioRaw != null) {
        const n = this.toNumber(ratioRaw, 0)
        return Math.max(0, Math.min(100, n <= 1 ? n * 100 : n))
      }

      const fullValue = this.getFullValue(d)
      const remainingValue = this.getRemainingValue(d)
      if (fullValue <= 0) return 0
      return Math.max(0, Math.min(100, (remainingValue / fullValue) * 100))
    },
    formatPercent(value) {
      return Math.round(this.toNumber(value, 0))
    },
    setupLights() {
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
      this.scene.add(ambientLight)

      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8)
      directionalLight.position.set(5, 5, 5)
      this.scene.add(directionalLight)

      const fillLight = new THREE.DirectionalLight(0xffffff, 0.3)
      fillLight.position.set(-5, -5, 5)
      this.scene.add(fillLight)
    },
    disposeScene(scene) {
      scene.traverse((obj) => {
        if (obj.geometry) {
          obj.geometry.dispose()
        }
        const { material } = obj
        if (material) {
          if (Array.isArray(material)) {
            material.forEach((m) => m && m.dispose && m.dispose())
          } else if (material.dispose) {
            material.dispose()
          }
        }
      })
    },
    rebuildSceneByData() {
      if (!this.scene) return

      this.disposeScene(this.scene)
      while (this.scene.children.length) {
        this.scene.remove(this.scene.children[0])
      }
      this.containers = []
      this.teaLevels = []

      this.scene.background = new THREE.Color(0x1a1a2e)
      this.setupLights()

      const list = Array.isArray(this.storageData) ? this.storageData : []
      const count = list.length
      if (!count) return

      const spacing = 4
      const startX = -((count - 1) * spacing) / 2

      list.forEach((data, index) => {
        const fullValue = this.getFullValue(data)
        const warningValue = this.getWarningValue(data)
        const warningRatio = fullValue > 0 ? warningValue / fullValue : 0.3
        const x = startX + index * spacing
        this.createContainer(x, this.getFillPercent(data), warningRatio)
      })
    },
    getStatusClass(capacity) {
      if (capacity > 60) return 'high'
      if (capacity > 30) return 'medium'
      return 'low'
    },
    getStatusText(capacity) {
      if (capacity > 60) return '充足'
      if (capacity > 30) return '正常'
      return '不足'
    },
    async saveStorageInfo(index) {
      const data = this.storageData[index]
      const payload = {
        id: data && data.id,
        name: data && data.name,
        sort: data && data.sort != null ? data.sort : index + 1,
        equipmentId: this.equipmentId,
        dtuNumber: data && data.dtuNumber ? data.dtuNumber : (this.initValue && this.initValue.dtuNumber ? this.initValue.dtuNumber : (this.$route && this.$route.query ? this.$route.query.dtuNumber : '')),
        powderValue: data && data.powderValue != null ? Number(data.powderValue) : 0,
        fullValue: data && data.fullValue != null ? Number(data.fullValue) : 0,
        warningValue: data && data.warningValue != null ? Number(data.warningValue) : 0
      }

      const res = await this.teaMaintainService.saveMaintain(payload)
      if (res && res.success) {
        this.$message({ type: 'success', message: '保存成功' })
        this.loadData()
      } else {
        this.$message.error((res && res.message) || '保存失败')
      }
    },
    createContainer(x, capacity, warningRatio) {
      const width = 2.2
      const height = 4
      const depth = 1.5

      const containerGeometry = new THREE.BoxGeometry(width, height, depth)
      const containerMaterial = new THREE.MeshPhongMaterial({
        color: 0x87CEEB,
        transparent: true,
        opacity: 0.35,
        side: THREE.DoubleSide,
        specular: 0xffffff,
        shininess: 80
      })

      const container = new THREE.Mesh(containerGeometry, containerMaterial)
      container.position.set(x, 0, 0)
      this.containers.push(container)
      this.scene.add(container)

      const frameMaterial = new THREE.MeshPhongMaterial({
        color: 0x4A90A4,
        specular: 0xffffff,
        shininess: 100
      })

      const frameThickness = 0.06
      const framePositions = [
        { pos: [-width/2, 0, -depth/2], rot: [0, 0, 0], size: [frameThickness, height, frameThickness] },
        { pos: [width/2, 0, -depth/2], rot: [0, 0, 0], size: [frameThickness, height, frameThickness] },
        { pos: [-width/2, 0, depth/2], rot: [0, 0, 0], size: [frameThickness, height, frameThickness] },
        { pos: [width/2, 0, depth/2], rot: [0, 0, 0], size: [frameThickness, height, frameThickness] },
        { pos: [0, height/2, 0], rot: [0, 0, 0], size: [width, frameThickness, depth] },
        { pos: [0, -height/2, 0], rot: [0, 0, 0], size: [width, frameThickness, depth] }
      ]

      framePositions.forEach((fp) => {
        const frameGeo = new THREE.BoxGeometry(fp.size[0], fp.size[1], fp.size[2])
        const frame = new THREE.Mesh(frameGeo, frameMaterial)
        frame.position.set(fp.pos[0] + x, fp.pos[1], fp.pos[2])
        frame.rotation.set(fp.rot[0], fp.rot[1], fp.rot[2])
        this.scene.add(frame)
      })

      const teaHeight = (capacity / 100) * height * 0.9
      const teaWidth = width * 0.9
      const teaDepth = depth * 0.9

      const teaGeometry = new THREE.BoxGeometry(teaWidth, teaHeight, teaDepth)
      const teaMaterial = new THREE.MeshPhongMaterial({
        color: 0x654321,
        specular: 0x3d2817,
        shininess: 15
      })

      const teaLevel = new THREE.Mesh(teaGeometry, teaMaterial)
      teaLevel.position.set(x, -height/2 + teaHeight/2, 0)
      teaLevel.userData = {
        originalCapacity: capacity,
        targetCapacity: capacity,
        width: teaWidth,
        depth: teaDepth,
        maxHeight: height * 0.9,
        containerHeight: height
      }
      this.teaLevels.push(teaLevel)
      this.scene.add(teaLevel)

      const teaSurfaceGeometry = new THREE.BoxGeometry(teaWidth, 0.05, teaDepth)
      const teaSurfaceMaterial = new THREE.MeshPhongMaterial({
        color: 0x8B4513,
        specular: 0x4a2c17,
        shininess: 20
      })
      const teaSurface = new THREE.Mesh(teaSurfaceGeometry, teaSurfaceMaterial)
      teaSurface.position.set(x, -height/2 + teaHeight - 0.025, 0)
      teaLevel.userData.surface = teaSurface
      this.scene.add(teaSurface)

      const warningLineMaterial = new THREE.MeshPhongMaterial({
        color: 0xff0000,
        transparent: true,
        opacity: 0.8,
        side: THREE.DoubleSide
      })
      const warningLineGeometry = new THREE.BoxGeometry(teaWidth, 0.08, teaDepth)
      const warningLine = new THREE.Mesh(warningLineGeometry, warningLineMaterial)
      const warningY = -height/2 + (warningRatio || 0.3) * height * 0.9
      warningLine.position.set(x, warningY, 0)
      teaLevel.userData.warningLine = warningLine
      this.scene.add(warningLine)
    },
    initScene() {
      if (!this.$refs.sceneRef) return

      const container = this.$refs.sceneRef
      const width = container.clientWidth
      const height = container.clientHeight

      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0x1a1a2e)

      this.camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 1000)
      this.camera.position.set(0, 0, 7)

      this.renderer = new THREE.WebGLRenderer({ antialias: true })
      this.renderer.setSize(width, height)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      container.appendChild(this.renderer.domElement)

      this.setupLights()
      this.rebuildSceneByData()

      this.animate()

      window.addEventListener('resize', this.onWindowResize)
    },
    animate() {
      this.animationId = requestAnimationFrame(() => this.animate())

      this.teaLevels.forEach((tea, index) => {
        const data = this.storageData && this.storageData[index]
        if (!data) return

        const targetCapacity = this.getFillPercent(data)
        const currentCapacity = tea.userData.currentCapacity || tea.userData.originalCapacity

        if (Math.abs(targetCapacity - currentCapacity) > 0.1) {
          tea.userData.currentCapacity = currentCapacity + (targetCapacity - currentCapacity) * 0.05

          const height = (tea.userData.currentCapacity / 100) * tea.userData.maxHeight
          this.updateTeaHeight(tea, height)
        }
      })

      this.renderer.render(this.scene, this.camera)
    },
    updateTeaHeight(tea, height) {
      const newHeight = Math.max(0.1, Math.min(height, tea.userData.maxHeight))
      const newGeometry = new THREE.BoxGeometry(tea.userData.width, newHeight, tea.userData.depth)
      tea.geometry.dispose()
      tea.geometry = newGeometry

      tea.position.y = -tea.userData.containerHeight / 2 + newHeight / 2

      if (tea.userData.surface) {
        tea.userData.surface.position.y = -tea.userData.containerHeight / 2 + newHeight - 0.025
        const surfaceGeo = new THREE.BoxGeometry(tea.userData.width, 0.05, tea.userData.depth)
        tea.userData.surface.geometry.dispose()
        tea.userData.surface.geometry = surfaceGeo
      }
    },
    updateWarningLine(index) {
      const tea = this.teaLevels[index]
      if (!tea || !tea.userData.warningLine) return

      const data = this.storageData[index]
      const fullValue = this.getFullValue(data)
      const warningValue = this.getWarningValue(data)
      const warningRatio = fullValue > 0 ? warningValue / fullValue : 0.3
      const warningY = -tea.userData.containerHeight / 2 + warningRatio * tea.userData.maxHeight
      tea.userData.warningLine.position.y = warningY
    },
    onWindowResize() {
      if (!this.$refs.sceneRef) return

      const width = this.$refs.sceneRef.clientWidth
      const height = this.$refs.sceneRef.clientHeight

      this.camera.aspect = width / height
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(width, height)
    }
  },
  props:{
    initValue:null
  },
  created(){
      // 创建服务实例，传入 httpService
      this.teaMaintainService = new TeaMaintainService(this.$httpservice)
      const initValue = this.initValue
      const routeEquipmentId = this.$route && this.$route.query && this.$route.query.equipmentId
      if (initValue && initValue.id != null) {
        this.equipmentId = initValue.id
      } else if (routeEquipmentId != null) {
        this.equipmentId = Number(routeEquipmentId) || 0
      } else {
        this.equipmentId = 0
      }
  },
  mounted() {
    this.initScene()
    if (this.equipmentId) {
      this.loadData()
    }
  },
  beforeDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
    }
    window.removeEventListener('resize', this.onWindowResize)

    if (this.renderer) {
      this.renderer.dispose()
    }

    this.containers.forEach(container => {
        container.geometry.dispose()
        container.material.dispose()
      })

    this.teaLevels.forEach(tea => {
      tea.geometry.dispose()
      tea.material.dispose()
    })
  }
}
</script>

<style scoped lang="less">
#teaStorageMaintain {
  width: 100%;
  height: 100%;
  min-height: 600px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;
}

.header {
  text-align: center;
  margin-bottom: 20px;

  h2 {
    color: #fff;
    font-size: 24px;
    margin: 0 0 10px 0;
  }

  p {
    color: #888;
    font-size: 14px;
    margin: 0;
  }
}

.scene-container {
  display: flex;
  gap: 25px;
  height: 480px;
}

.scene {
  flex: 1;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.info-panel {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-row {
  display: flex;
  gap: 10px;

  .form-group-half {
    flex: 1;

    label {
      display: block;
      color: #ccc;
      font-size: 12px;
      margin-bottom: 4px;
    }

    .form-input {
      width: 100%;
      padding: 6px 10px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      font-size: 13px;
      outline: none;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        background: rgba(255, 255, 255, 0.15);
      }

      &::placeholder {
        color: #666;
      }
    }
  }
}

.storage-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px;
  backdrop-filter: blur(10px);

  .storage-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .storage-name {
      color: #fff;
      font-size: 14px;
      font-weight: bold;
    }

    .storage-status {
      padding: 2px 8px;
      border-radius: 10px;
      font-size: 10px;
      font-weight: bold;

      &.high {
        background: #4CAF50;
        color: #fff;
      }

      &.medium {
        background: #FF9800;
        color: #fff;
      }

      &.low {
        background: #f44336;
        color: #fff;
      }
    }
  }

  .form-group {
    margin-bottom: 10px;

    label {
      display: block;
      color: #ccc;
      font-size: 12px;
      margin-bottom: 4px;
    }

    .form-input {
      width: 100%;
      padding: 6px 10px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      font-size: 13px;
      outline: none;
      transition: all 0.3s ease;

      &:focus {
        border-color: #667eea;
        background: rgba(255, 255, 255, 0.15);
      }

      &::placeholder {
        color: #666;
      }
    }
  }

  .progress-bar {
    height: 8px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;

    .progress-fill {
      height: 100%;
      border-radius: 4px;
      transition: width 0.3s ease;

      &.high {
        background: linear-gradient(90deg, #4CAF50, #8BC34A);
      }

      &.medium {
        background: linear-gradient(90deg, #FF9800, #FFC107);
      }

      &.low {
        background: linear-gradient(90deg, #f44336, #FF5252);
      }
    }
  }

  .storage-info {
    display: flex;
    justify-content: space-between;
    color: #aaa;
    font-size: 12px;
    margin-bottom: 10px;
  }

  .save-btn {
    width: 100%;
    padding: 7px;
    margin-top: 6px;
    border: none;
    border-radius: 5px;
    background: linear-gradient(135deg, #4CAF50, #45a049);
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/teaStorageMaintain.vue